import { api } from '../Api'

export class CronogramaService {

  getCronograma(cnpj, mes, ano, idPrestador) {
    return api.get('/cronograma/').then(res => res.data)
  }

}
